import deepmerge from "@node/deepmerge";

let locales = {};
const modules = import.meta.glob("@o-din-rounds/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-rounds/src/rounds/store.js";
import menu from "@o-din-rounds/src/rounds/menu.json";

export default {
  routes: [
    { path: '/round/issues', component: () => import("./views/rounds/issues/Index.vue") },
    { path: '/round/issues/archive', component: () => import("./views/rounds/issues/Archive.vue") },
    { path: '/round/issues/report_by_executor', component: () => import("./views/rounds/issues/ReportByExecutor.vue") },
    { path: '/round/issues/:id', component: () => import("./views/rounds/issues/Show.vue") },
    { path: '/round/checklists', component: () => import("./views/rounds/checklists/Index.vue") },
    { path: '/round/checklists/:id/edit', component: () => import("./views/rounds/checklists/Form.vue") },
    { path: '/round/checklists/new', component: () => import("./views/rounds/checklists/Form.vue") },
    { path: '/round/checklists/:id', component: () => import("./views/rounds/checklists/Show.vue") },
    { path: '/round/work_plans', component: () => import("./views/rounds/work_plans/Index.vue") },
    { path: '/round/work_plans/new', component: () => import("./views/rounds/work_plans/Form.vue") },
    { path: '/round/work_plans/:id/edit', component: () => import("./views/rounds/work_plans/Form.vue") },
    { path: '/round/works', component: () => import("./views/rounds/works/Index.vue") },
    { path: '/round/works/new', component: () => import("./views/rounds/works/Form.vue") },
    { path: '/round/works/:id/edit', component: () => import("./views/rounds/works/Form.vue") },
  ],
  locales,
  store,
  menu: [menu]
}
